import { matchPath } from "react-router-dom";

import { artifactTypeUrl } from "@helpers/constants";

export const artifactTypePaths = Object.values(artifactTypeUrl)
  .concat("artifact")
  .join("|");

export const meetingsRoutes = [
  "/calendar/user/:userId",
  "/calendar",
  "/meetings/:type/user/:userId",
  "/meetings/:type",
  "/meetings",
];

// Route patterns that can be opened in a sidebar overlay (with toWithBackground).
// These must match the sidebar routes in routes.tsx.
export const sidebarRoutePaths = [
  ...Object.values(artifactTypeUrl).map((path) => `/${path}-new`),
  `/(${artifactTypePaths})/:artifactId`,
  `/meeting/:meetingGroupId/:meetingId/(${artifactTypePaths})/:artifactId`,
  `/profile/:profileId`,
  `/meeting/:meetingGroupId/:meetingId`,
  `/assessments/assessment/delivery/:deliveryId`,
  `/assessments/assessment/:assessmentId`,
];

/**
 * Extracts the pathname from a URL if it's an internal Topicflow link.
 * Returns null for external URLs.
 */
export const getInternalPathname = (url: string): string | null => {
  try {
    const urlObj = new URL(url, window.location.origin);
    const { hostname } = urlObj;
    const isInternal =
      hostname === window.location.hostname ||
      hostname.endsWith(".topicflow.com");
    if (!isInternal) return null;
    return urlObj.pathname + urlObj.search + urlObj.hash;
  } catch {
    // Relative paths (e.g. "/recognition/123") are internal
    return url;
  }
};

/**
 * Checks if a URL (absolute or relative) can be opened in a sidebar overlay.
 */
export const canOpenInSidebar = (url: string): boolean => {
  const internalPath = getInternalPathname(url);
  if (!internalPath) return false;
  const pathname = internalPath.split(/[?#]/)[0];
  return sidebarRoutePaths.some((pattern) =>
    matchPath(pathname, { path: pattern, exact: true }),
  );
};
